import React from "react";

import type { CompanyResearchSelfCompanyKnowledgeReference } from "../lib/companyResearch";
import { getKnowledgeItemDisplayName, getKnowledgeTypeLabel } from "../lib/knowledge";

type CompanyResearchSelfCompanyKnowledgeProps = {
  knowledge?: CompanyResearchSelfCompanyKnowledgeReference | null;
  variant?: "line" | "panel";
};

export function CompanyResearchSelfCompanyKnowledge({
  knowledge,
  variant = "line",
}: CompanyResearchSelfCompanyKnowledgeProps) {
  if (!knowledge) return null;

  const sourceType = knowledge.type || knowledge.source_type;
  const title = sourceType === "url"
    ? getKnowledgeItemDisplayName({
        type: "url",
        title: knowledge.title,
        original_filename: null,
      })
    : knowledge.title?.trim() || "自社ナレッジ";
  const typeLabel = getKnowledgeTypeLabel(sourceType);

  if (variant === "panel") {
    return (
      <div className="mt-3 rounded-2xl border border-[#F2E6DA] bg-[#FFFCFA] px-3 py-3">
        <p className="text-xs font-black text-[#A67C52]">参照した自社資料</p>
        <p className="mt-1 break-words text-sm font-black text-[#5D4D46] [overflow-wrap:anywhere]">
          {title}
        </p>
        <p className="mt-1 text-xs font-bold text-[#8A746A]">種別: {typeLabel}</p>
      </div>
    );
  }

  return (
    <p className="mt-2 break-words text-xs font-bold leading-5 text-[#8A746A] [overflow-wrap:anywhere]">
      <span className="font-black text-[#5D4D46]">参照資料: </span>
      <span>{title}</span>
      <span className="ml-2 rounded-full bg-[#FFF3E9] px-2 py-0.5 text-[11px] font-black text-[#A46D4C]">
        {typeLabel}
      </span>
    </p>
  );
}
